export class ColorUtility {
    public static hexToRgb(hex: string) {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }

    public static colorIsLight(hex: string): boolean {
        const { r, g, b } = this.hexToRgb(hex);
        const o = Math.round(((r * 299) + (g * 587) + (b * 114)) / 1000);
        return (o > 180);
    }

    public static idealTextColor(hex: string): string {
        const darkText = '#444';
        const lightText = '#fff';

        if (!hex || hex.toLocaleLowerCase() === 'transparent')
            return darkText;

        return this.colorIsLight(hex)
            ? darkText
            : lightText;
    }
}